import { render } from "./QuoteBand.vue?vue&type=template&id=4ae82d5a&scoped=true"
import script from "./QuoteBand.vue?vue&type=script&lang=js"
export * from "./QuoteBand.vue?vue&type=script&lang=js"

import "./QuoteBand.vue?vue&type=style&index=0&id=4ae82d5a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae82d5a"]])

export default __exports__